module.exports = __webpack_public_path__ + "static/img/home_product_validation.853daa7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/home_product_validation.jpg
// module id = 1404
// module chunks = 1